import Axios from "axios";
import { ApiResultModel, IReferenceKey } from "../models/common.model";
import { IGetInstallmentListForRepaymentResponse, IGetInstallmentsPaymentInfoResponse, IGetIpgInfoRequest } from "../models/repayment.model";
import { APIBASE_URL, REPAYMENT } from "../config/cacheKey";

export const GetInstallmentsPaymentInfo = (
    data: IReferenceKey
): Promise<IGetInstallmentsPaymentInfoResponse> => {
    return Axios.post<ApiResultModel<IGetInstallmentsPaymentInfoResponse>>(
        APIBASE_URL + REPAYMENT + '/GetInstallmentsPaymentInfo',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const GetInstallmentListForRepayment = async (
    data: { referenceKey: string }
): Promise<IGetInstallmentListForRepaymentResponse> => {
    return await Axios.post<ApiResultModel<IGetInstallmentListForRepaymentResponse>>(
        APIBASE_URL + REPAYMENT + '/GetInstallmentListForRepayment',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetIpgInfo = async (
    data: IGetIpgInfoRequest
): Promise<{ ipgUrl: string }> => {
    return await Axios.post<ApiResultModel<{ ipgUrl: string }>>(
        APIBASE_URL + REPAYMENT + '/GetIpgInfo',
        data
    ).then((result) => {
        return result.data.data;
    });
};
